import { redirect, type RouteObject } from 'react-router';

import { PermissionResource } from '@entities/tenant/permission';

import { lazyComponent } from '../../../lazy-component';
import { requirePermission } from '../../../require-permission';
import { debtorsLoader } from './debtors-loader';

// Gated per page, not per group: overdrafts have their own Resource, independent of clients.
export const debtorsRoutes: RouteObject = {
  children: [
    {
      path: '/debtors',
      lazy: lazyComponent(
        () => import('@pages/tenant/debtor/debtors-page'),
        'DebtorsPage',
      ),
      children: [
        { index: true, loader: () => redirect('debtors/clients') },
        {
          path: 'clients',
          loader: debtorsLoader,
          lazy: lazyComponent(
            () => import('@pages/tenant/debtor/clients-page'),
            'ClientsPage',
          ),
        },
        {
          path: 'agents',
          loader: debtorsLoader,
          lazy: lazyComponent(
            () => import('@pages/tenant/debtor/agents-page'),
            'AgentsPage',
          ),
        },
        {
          path: 'overdrafts',
          loader: requirePermission(PermissionResource.TenantOverdrafts),
          lazy: lazyComponent(
            () => import('@pages/tenant/debtor/overdrafts-page'),
            'OverdraftsPage',
          ),
        },
      ],
    },
    {
      path: '/debtors/clients/:clientId',
      loader: debtorsLoader,
      lazy: lazyComponent(
        () => import('@pages/tenant/debtor/client-details-page'),
        'ClientDetailsPage',
      ),
    },
  ],
};
